import { ExecutiveSummaryDetail } from '@containers/executive-summary/models/executive-summary-detail';
import { ExecutiveSummaryService } from '@core/services/executive-summary.service';
import { ProfileService } from '@core/services/profile.service';
import { Profile } from '@model/profile';
import { AxiosResponse } from 'axios';
import { catchError, firstValueFrom, forkJoin, throwError } from 'rxjs';

export interface ExecutiveSummaryDefaultData {
  profile: Profile;
  exSumDetail: ExecutiveSummaryDetail;
}

export default async function getExecutiveSummaryDefaultData(exSumId: number | string): Promise<Partial<ExecutiveSummaryDefaultData>> {
  const data$ = forkJoin({
    profile: ProfileService.getProfile(),
    exSumDetail: ExecutiveSummaryService.getExSumDetail(exSumId),
  }).pipe(
    catchError((e: AxiosResponse) => {
      if (e.status === 404) {
        window.location.href = '/';
      }
      return throwError(() => e);
    })
  );
  return await firstValueFrom(data$);
}
